/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserPaymentMethods200ResponseAllOfData } from './GetUserPaymentMethods200ResponseAllOfData';
import {
    GetUserPaymentMethods200ResponseAllOfDataFromJSON,
    GetUserPaymentMethods200ResponseAllOfDataFromJSONTyped,
    GetUserPaymentMethods200ResponseAllOfDataToJSON,
} from './GetUserPaymentMethods200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserPaymentMethods200Response
 */
export interface GetUserPaymentMethods200Response {
    /**
     * 
     * @type {GetUserPaymentMethods200ResponseAllOfData}
     * @memberof GetUserPaymentMethods200Response
     */
    data: GetUserPaymentMethods200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetUserPaymentMethods200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetUserPaymentMethods200Response interface.
 */
export function instanceOfGetUserPaymentMethods200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetUserPaymentMethods200ResponseFromJSON(json: any): GetUserPaymentMethods200Response {
    return GetUserPaymentMethods200ResponseFromJSONTyped(json, false);
}

export function GetUserPaymentMethods200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserPaymentMethods200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserPaymentMethods200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetUserPaymentMethods200ResponseToJSON(value?: GetUserPaymentMethods200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserPaymentMethods200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

